<div class="container-fluid docma-bg-dark-light-2 pad-it" [style.maxHeight]="'80px'">
  <header class="docma-c-dark-3 max-width">
      <img class="pull-left logo" src="assets/mm2.png" alt="MM Logo" />
      <h1 class="pull-left header-text"> <span class="hidden-xs">mydocma MM </span>weblink</h1>

      <a href="http://www.edr-software.com/" target="_blank">
          <img class="pull-right logo " src="assets/edr-logo.svg" alt="EDR Logo" />
      </a>
      <div class="pull-right" style="margin-top: 10px">

      <span *ngIf="!mediaQueryService.isXs" style="text-align: center; padding-right: 20px" > {{ 'v' + appComponent.version }}</span>

      <div class="btn-group" dropdown>
            <button  dropdownToggle type="button" class="btn  dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="glyphicon glyphicon-user" ></span>
            <span class="hidden-xs">{{currentUser}}</span>
            <span class="caret"></span>
            </button>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" >
                    <li role="menuitem"  >
                            <a href="javascript:" class="dropdown-item hidden-sm hidden-md hidden-lg min-height ">{{currentUser}}</a>
                    </li>
                    <li role="separator" class="divider hidden-sm hidden-md hidden-lg min-height"></li>
                    <li role="menuitem" *ngIf="currentUser" >
                        <a class="dropdown-item"
                           href="javascript:" (click)="changeUser()" ><span class="glyphicon glyphicon-user"  ></span> {{ 'weblink.button.changeUser' | translate }}</a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li role="menuitem"  *ngIf="currentUser" >
                            <a class="dropdown-item"
                               href="javascript:" (click)="logout()" ><span class="glyphicon glyphicon-log-out" ></span> {{ 'weblink.button.logout' | translate }}</a>
                    </li>
                    <li role="separator" class="divider"></li>

                    <li role="menuitem" *ngIf="mediaQueryService.isXs" >
                      <a class="dropdown-item" style="text-align: center" > {{ 'v' + appComponent.version  }}</a>
                    </li>

             </ul>
        </div>
        </div>

  </header>
</div>




